import { getLinkTarget } from '@anm/helpers/upgradeLink';
import React, { FC } from 'react';
import * as semrush from '@anm/helpers/semrush';
import { DropdownContentItem, DropdownContentWrapper } from './Wrapper';
import vtConfig from '../../../../config';

const {
  urls: { wave: waveUrl }
} = vtConfig();

export const resourcesNavList = [
  {
    title: 'Blog',
    href: `${waveUrl}blog/`
  },
  {
    title: 'Knowledge Base',
    href: `${waveUrl}help/`
  },
  {
    title: 'Video Tutorials',
    href: `${waveUrl}tutorial/`
  },
  !semrush.isSemrushIframe() && {
    title: 'FB Community',
    href: 'https://www.facebook.com/groups/wave.video/'
  },
  {
    title: 'Affiliate program',
    href: 'https://animatron.tapfiliate.com/'
  },
  {
    title: 'Weekly Webinars',
    href: 'https://wave.video/blog/live-better-show/'
  }
].filter(v => v) as ListItem[];

export type ListContentProps = {
  list: ListItem[];
};

export type ListItem = {
  title: string;
  href: string;
};

const DropdownContent: FC<ListContentProps> = ({ list }) => {
  const target = getLinkTarget();

  return (
    <DropdownContentWrapper>
      {list.map(({ href, title }) => (
        <li key={title + target}>
          <DropdownContentItem {...{ href, target }}>{title}</DropdownContentItem>
        </li>
      ))}
    </DropdownContentWrapper>
  );
};

export default DropdownContent;
